if (!customElements.get('routine-timeline-section')) {
  customElements.define('routine-timeline-section', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.cards = Array.from(this.querySelectorAll('.routine-card'));
      this.currentIndex = 0;

      if (!this.cards.length) return;

      this.desktopMedia = window.matchMedia('(min-width: 750px)');
      this.desktopMedia.addEventListener('change', () => {
        this.showSlide(this.currentIndex, false);
      }, options);

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.showSlide(index), options);
        tab.addEventListener('keydown', (event) => {
          let nextIndex;
          switch (event.key) {
            case 'ArrowLeft': nextIndex = index - 1; break;
            case 'ArrowRight': nextIndex = index + 1; break;
            case 'Home': nextIndex = 0; break;
            case 'End': nextIndex = this.tabs.length - 1; break;
            default: return;
          }
          event.preventDefault();
          this.showSlide(nextIndex);
          this.tabs[this.currentIndex].focus({ preventScroll: true });
        }, options);
      });

      this.querySelector('.routine-prev')?.addEventListener('click', () => {
        this.showSlide(this.currentIndex - 1);
      }, options);
      this.querySelector('.routine-next')?.addEventListener('click', () => {
        this.showSlide(this.currentIndex + 1);
      }, options);

      this.addEventListener('shopify:block:select', (event) => {
        const index = this.cards.findIndex((card) => card.dataset.blockId === event.detail.blockId);
        if (index !== -1) this.showSlide(index);
      }, options);

      this.showSlide(0, false);
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    showSlide(index, revealTab = true) {
      this.currentIndex = (index + this.cards.length) % this.cards.length;
      const desktopGrid = this.dataset.desktopGrid === 'true' && this.desktopMedia.matches;
      this.cards.forEach((card, cardIndex) => {
        const selected = cardIndex === this.currentIndex;
        card.classList.toggle('active', selected);
        card.hidden = !desktopGrid && !selected;
        card.tabIndex = desktopGrid ? -1 : 0;
        const tab = this.tabs[cardIndex];
        if (tab) {
          tab.classList.toggle('active', selected);
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        }
      });

      if (revealTab && this.tabs.length) {
        const tab = this.tabs[this.currentIndex];
        const tabList = tab.parentElement;
        const tabBounds = tab.getBoundingClientRect();
        const listBounds = tabList.getBoundingClientRect();
        if (tabBounds.left < listBounds.left) {
          tabList.scrollLeft += tabBounds.left - listBounds.left;
        } else if (tabBounds.right > listBounds.right) {
          tabList.scrollLeft += tabBounds.right - listBounds.right;
        }
      }
    }
  });
}
